import React from 'react';

import Link from '../Link/Link';
import { LinkContainer } from '../Link/Link.styles';
import { SectionRoute } from './SideNav';
import { SideNavRoute } from '../../types';
import { LinkStyleButton, SectionTitle } from './SideNav.styles';
import constants from '../../../abstracts/constants';

export const handleRoute = (route: SideNavRoute): React.ReactNode => {
  if (route.button)
    return (
      <LinkContainer key={`button--${route.title}`}>
        <LinkStyleButton
          title={route.title}
          data-qa-id={route.dataQaId}
          onClick={route.onClick}
          disabled={route.disabled}
          size={route.size}
          onMouseDown={(e) => e.preventDefault()}
        >
          {route.title}
        </LinkStyleButton>
      </LinkContainer>
    );
  return (
    <Link
      key={`route--${route.title}`}
      title={route.title}
      path={route.path}
      href={route.href}
      dataQaId={route.dataQaId}
      selected={route.selected}
      disabled={route.disabled}
      disableVisited={true}
      size={route.size}
      router={route.router}
    />
  );
};

export const handleSectionRoute = (routes: SectionRoute): React.ReactNode => {
  return (
    <React.Fragment key={routes.sectionTitle}>
      <SectionTitle data-qa-id={routes.dataQaId} size={routes.size}>
        {routes.sectionTitle}
      </SectionTitle>
      {routes.routes.map((sectionRoute: SideNavRoute) => handleRoute(sectionRoute))}
    </React.Fragment>
  );
};

export const renderRoutes = (routes: any): React.ReactNode => {
  if (!Array.isArray(routes)) return handleSectionRoute(routes);

  return routes.map((route: any) => {
    if (route.sectionTitle) return handleSectionRoute(route);

    return handleRoute(route);
  });
};

export const handleSize = (size: string) => {
  switch (size) {
    case 'small':
      return constants.XSMALL;
    case 'medium':
      return constants.MEDIUM;
    case 'large':
      return constants.LARGE;
    default:
      return constants.MEDIUM;
  }
};
